import gql from "graphql-tag";

export const EXPAND_PERMISSIONS = gql`
    mutation expandPermissions($permissions:String!) { 
        permissionService_expandPermissions(permissions:$permissions)
    }
`;